import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BreadcrumbModule} from 'angular-crumbs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CookieService } from 'ngx-cookie-service';
import { PurchaseComponent } from './purchase/purchase.component';
import { IdealsOneApiService } from './services/ideals-one-api.service';
import { PayConfirmationComponent } from './pay-confirmation/pay-confirmation.component';
import { PaymentComponent } from './payment/payment.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { dateChange } from './payment/date.pipe'
import { SortPipe } from './purchase/sort.pipe';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [
    AppComponent,
    PurchaseComponent,
    PayConfirmationComponent,
    PaymentComponent,
    dateChange,
    SortPipe,
    FooterComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    NgbModule
  ],
  providers: [IdealsOneApiService, CookieService, Title ],
  bootstrap: [AppComponent]
})
export class AppModule { }
